import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

// Higher resolution map data
const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-50m.json";

// South American countries with ISO 3166-1 numeric codes
const SOUTH_AMERICAN_COUNTRIES = [
    { code: "032", name: "Argentina" },
    { code: "068", name: "Bolivia" },
    { code: "076", name: "Brazil" },
    { code: "152", name: "Chile" },
    { code: "170", name: "Colombia" },
    { code: "218", name: "Ecuador" },
    { code: "238", name: "Falkland Islands" },
    { code: "254", name: "French Guiana" },
    { code: "328", name: "Guyana" },
    { code: "600", name: "Paraguay" },
    { code: "604", name: "Peru" },
    { code: "740", name: "Suriname" },
    { code: "858", name: "Uruguay" },
    { code: "862", name: "Venezuela" }
].sort((a, b) => a.name.localeCompare(b.name));

const SOUTH_AMERICAN_CODES = SOUTH_AMERICAN_COUNTRIES.map(c => c.code);
const ITEMS = SOUTH_AMERICAN_COUNTRIES.map(c => ({ id: c.code, name: c.name }));

const SouthAmericaMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{
                scale: 550,
                center: [-58, -26]
            }}
            width={600}
            height={800}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => SOUTH_AMERICAN_CODES.includes(geo.id))
                        .map((geo) => {
                            const countryCode = geo.id;
                            const isVisited = visited.includes(countryCode);

                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(countryCode)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="south_america"
            analyticsLocationType="south_american_country"
            trackingLabel="South America Map"
            storageKey="south_america_map"
            title="🌎 South America Travel Map"
            subtitle="Click on countries you've visited, or use the checklist below!"
            items={ITEMS}
            noun="Countries"
            unitLabel="countries"
            captionUnit="South American countries"
            share={{
                region: 'South America',
                fileName: 'visited-south-america-map.png',
                trackId: 'south_america'
            }}
            renderMap={renderMap}
        />
    );
};

export default SouthAmericaMapSection;
